import { Path,SVG } from '@wordpress/primitives';


export const Icon = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path
			d="M19 6.25C20.5188 6.25 21.75 7.48122 21.75 9V15C21.75 16.5188 20.5188 17.75 19 17.75H5C3.48122 17.75 2.25 16.5188 2.25 15V9C2.25 7.48122 3.48122 6.25 5 6.25H19ZM5 7.75C4.30964 7.75 3.75 8.30964 3.75 9V15C3.75 15.6904 4.30964 16.25 5 16.25H8.25V7.75H5ZM9.75 16.25H14.25V7.75H9.75V16.25ZM15.75 16.25H19C19.6904 16.25 20.25 15.6904 20.25 15V9C20.25 8.30964 19.6904 7.75 19 7.75H15.75V16.25Z"
		/>
	</SVG>
);
